import useSWR, { type SWRConfiguration } from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcher from '@/lib/swr/fetcher';
import type Opportunity from '@/types/api/Opportunity';
import type OpportunityFilter from '@/types/OpportunityFilter';
import createOpportunitiesFetcherKey from '@/utils/opportunities/createOpportunitiesFetcherKey';

type UseOpportunitiesProps = {
  filter?: OpportunityFilter;
  swrOptions?: SWRConfiguration;
};

export default function useOpportunities({
  filter,
  swrOptions,
}: UseOpportunitiesProps) {
  const ownerOrgId = useOwnerOrgId();
  const key = createOpportunitiesFetcherKey({
    ownerOrgId,
    ...filter,
  });

  return useSWR<
    { opportunities: Opportunity[]; totalHits: number } | undefined
  >(key, fetcher, swrOptions);
}
